import { Box, Button, Typography } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import Locale from '/b2b/common/components/Locale';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/PersonOutline';
import PropTypes from 'prop-types';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import styles from './TopBar.styles';
import { translate } from '/b2b/common/helpers/i18n';

const useStyles = makeStyles(styles);

/*
 * Fullscreen-mode header: Chats menu, New-conversation button, centered title, and
 * the Escalate action. Presentational only — behavior comes from the shell via
 * callbacks. Other panel modes (sidebar/widget) provide their own headers.
 */
const TopBar = props => {
    const { activeConversationId, title, canEscalate, onOpenChats, onNewConversation, onEscalate } =
        props;
    const classes = useStyles(props);

    return (
        <Box className={classes.topBar}>
            <Box className={classes.topBarLeft}>
                <Button
                    className={classes.chatsButton}
                    variant="outlined"
                    size="small"
                    startIcon={<MenuIcon />}
                    onClick={onOpenChats}
                >
                    <Locale path="aiAssistant.buttons.chats.label" />
                </Button>
                {activeConversationId && (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={onNewConversation}
                        aria-label={translate('aiAssistant.buttons.newChat.ariaLabel')}
                    >
                        <Locale path="common.new" />
                    </Button>
                )}
            </Box>
            <Box className={classes.topBarContent}>
                {title && (
                    <Typography variant="body1" className={classes.topBarTitle}>
                        {title}
                    </Typography>
                )}
            </Box>
            {canEscalate && (
                <Box className={classes.topBarRight}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<PersonIcon />}
                        onClick={onEscalate}
                    >
                        <Locale path="aiAssistant.buttons.escalate.label" />
                    </Button>
                </Box>
            )}
        </Box>
    );
};

TopBar.propTypes = {
    activeConversationId: PropTypes.string,
    title: PropTypes.string,
    canEscalate: PropTypes.bool,
    onOpenChats: PropTypes.func.isRequired,
    onNewConversation: PropTypes.func.isRequired,
    onEscalate: PropTypes.func.isRequired,
};

export default TopBar;
